import { render } from "./createSms.vue?vue&type=template&id=3b04512d&scoped=true"
import script from "./createSms.vue?vue&type=script&lang=js"
export * from "./createSms.vue?vue&type=script&lang=js"

import "./createSms.vue?vue&type=style&index=0&id=3b04512d&lang=less&scoped=true"

import exportComponent from "E:\\work\\高大\\pps\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b04512d"]])

export default __exports__